var security = {};

// 初始事件正则
var objOnEvents = {};
var reAllEvents;
initAllEventsRe();
function initAllEventsRe(){
    var doc = document;
    var arrDoms = [window, doc.createElement("form")];
    try{
        arrDoms.push(doc.createElement("img"));
        arrDoms.push(doc.createElement("iframe"));
        arrDoms.push(doc.createElement("object"));
        arrDoms.push(doc.createElement("embed"));
        arrDoms.push(doc.createElement("audio"));
    }
    catch(e){}
    var dom;
    var key;
    for(var i=0,c=arrDoms.length;i<c;i++){
        dom = arrDoms[i];
        for(key in dom){
            if(/^on/.test(key)){
                objOnEvents[key.substring(2)] = 1;
            }
        }
    }
    var arrAllEvents = [];
    for(key in objOnEvents){
        arrAllEvents.push(key);
    }
    if(arrAllEvents.length > 0){
        reAllEvents = new RegExp('([\'"`\\s\\/]on(?:'+arrAllEvents.join('|')+'))\\s*=','ig');
    }
    else{
        reAllEvents = /(['"`\s\/]on(\w+))\s*=/ig;
    }
}

// 判断是否为Alibaba应用的URL
security.isAlibabaAppUrl = function(url){
    var reAlibabaUrl = /^https?:\/\/(([^\:\/]+\.)?(alibaba|aliexpress)\.com|\d+\.\d+\.\d+\.\d+|totoroserver.alibaba.net)(\:\d+)?\//i;
    var reStyleUrl = /^https?:\/\/(style|img)\.(alibaba|aliexpress)\.com(\:\d+)?\//i;
    return (reAlibabaUrl.test(url) || (/^(\w+):\/\//i.test(url) === false && reAlibabaUrl.test(location.href))) && reStyleUrl.test(url) === false;
};

// html转义
// 经测试，下方代码比正则替换效率要高很多
security.encodeHTML = function(str){
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#96;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

// 过滤html中可能引发XSS的代码
security.htmlFilter = function(str, args, securityDebug){

    var reAllTags = /<(script|link|frame)([^\w])/ig;
    var reAttrs = /[\'"`\s\/](srcdoc)\s*=/ig;
    var reBadSrc = /[\'"`\s\/]src\s*=\s*['"]?\s*(javascript:|data\s*:\s*text\/html)/ig;

    // 过滤打点 (暂时取消打点)
    try{
        var clickstat = window.dmtrack && dmtrack.clickstat;
        var caller = args.callee.caller || '';
        var callerFunc = caller.toString().substr(0, 300);
        var match1 = str.match(reAllTags);
        var match2 = str.match(reAllEvents);
        var match3 = str.match(reAttrs);
        var match4 = str.match(reBadSrc);
        var match = match1 || match2 || match3 || match4;
        if(clickstat && match !== null){
            clickstat(location.protocol+'//stat.alibaba.com/event/common.html', {id:15669, ext:'url='+encodeURIComponent(location.href)+'|caller='+encodeURIComponent(callerFunc)+'|html='+encodeURIComponent(match[0])+'|ver=0725'});
        }
    }
    catch(e){}

    if(securityDebug !== true){
        str = String(str);

        // 过滤script & link...
        str  = str.replace(reAllTags, '<$10$2');
        // 过滤on事件
        str = str.replace(reAllEvents, '$10=');
        // 过滤srcdoc属性
        str = str.replace(reAttrs, ' $10=');
        // 过滤危险src: javascript: data:
        str = str.replace(reBadSrc, ' src0="');
    }

    return str;
};

//获取token，兼容带引号的cookie
security.getCToken = function(){
    var tockenMatch = ['', ''];
    try {
        var cookie = document.cookie;
        var xmanMatch = (cookie && cookie.match(/(?:^|;)\s*xman_us_t\s*=\s*([^;]+)/)) || '';
        if (xmanMatch) {
            tockenMatch = (xmanMatch[1] && xmanMatch[1].match(/ctoken\s*=\s*([^&]+)/)) || '';
        }
    } catch (err) {
        console.warn('Error(getCToken)', err);
    }
  
    return tockenMatch[1] || '';
};

// 混入ctoken(CSRF)
security.mixCsrfToken = function(url){
    var cookie = document.cookie;
    var match = cookie && cookie.match(/(?:^|;)\s*xman_us_t\s*=\s*([^;]+)/);
    if(match){
        match = match[1].match(/(?:^|&)\s*ctoken\s*=\s*([^&]+)/);
    }
    var csrf_token = window['_intl_csrf_token_'] || (match ? match[1] : security.getCToken());

    if(csrf_token &&
        security.isAlibabaAppUrl(url) &&
        /(\?|&)ctoken=/.test(url) === false){
        url += ( /\?/.test( url ) ? '&' : '?' ) + 'ctoken=' + csrf_token;
    }

    // 支持tbtoken
    match = cookie && cookie.match(/(?:^|;)\s*_tb_token_\s*=\s*([^;]+)/);

    if(match &&
        /^https?:\/\/(pre-)?(mysourcing|ta|biz|onetouch|onetouch-partner|jsb|fin|fin-partner)\.alibaba\.com\//.test(location.href) &&
        /(\?|&)_tb_token_=/.test(url) === false){
        url += ( /\?/.test( url ) ? '&' : '?' ) + '_tb_token_=' + match[1];
    }

    return url;
};

// hack jQuery
security.hookJquery = function ($) {
    // 防止重复hack
    if(!$.fn.rawHtml){
        // 1. html->rawHtml
        $.fn.rawHtml = $.fn.html;
        $.fn.html = function( value ){
            var args = Array.prototype.slice.call(arguments);
            if ( typeof value === 'string') {
                args[0] = security.htmlFilter(value, arguments, $.securityDebug);
            }
            return $.fn.rawHtml.apply(this, args);
        };
        $.fn.rawLoad = function( url, params, callback ){
            if ( typeof url !== "string") {
                return $.fn.load.apply( this, arguments );
            }
            var rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;

            // Don't do a request if no elements are being requested
            if ( !this.length ) {
                return this;
            }

            var selector, type, response,
                self = this,
                off = url.indexOf(" ");

            if ( off >= 0 ) {
                selector = url.slice( off, url.length );
                url = url.slice( 0, off );
            }

            // If it's a function
            if ( $.isFunction( params ) ) {

                // We assume that it's the callback
                callback = params;
                params = undefined;

            // Otherwise, build a param string
            } else if ( params && typeof params === "object" ) {
                type = "POST";
            }

            // Request the remote document
            $.ajax({
                url: url,

                // if "type" variable is undefined, then "GET" method will be used
                type: type,
                dataType: "html",
                data: params,
                complete: function( jqXHR, status ) {
                    if ( callback ) {
                        self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
                    }
                }
            }).done(function( responseText ) {

                // Save response for use in complete callback
                response = arguments;

                // See if a selector was specified
                self.rawHtml( selector ?

                    // Create a dummy div to hold the results
                    $("<div>")

                        // inject the contents of the document in, removing the scripts
                        // to avoid any 'Permission Denied' errors in IE
                        .append( responseText.replace( rscript, "" ) )

                        // Locate the specified elements
                        .find( selector ) :

                    // If not, just inject the full result
                    responseText );

            });

            return this;
        };
        // 2. ajax注入csrf token
        $.ajaxPrefilter( "*", function( s) {
            s.url = security.mixCsrfToken(s.url);
        });
    }
};

// hack zepto
// security.hookZepto = function ($) {
//     // 防止重复hack
//     if(!$.fn.rawHtml){
//         // 1. html->rawHtml
//         $.fn.rawHtml = $.fn.html;
//         $.fn.html = function( value ){
//             var args = Array.prototype.slice.call(arguments);
//             if ( typeof value === 'string') {
//                 args[0] = security.htmlFilter(value, arguments, $.securityDebug);
//             }
//             return $.fn.rawHtml.apply(this, args);
//         };
//         // 2. ajax注入csrf token
//         $.rawAjax = $.ajax;
//         $.ajax = function(options){
//             if(options && options.url){
//                 options.url = security.mixCsrfToken(options.url);
//             }
//             return $.rawAjax.call(this, options);
//         };

//         $.rawAjaxJSONP = $.ajaxJSONP;
//         $.ajaxJSONP = function(options){
//             if(options && options.url){
//                 options.url = security.mixCsrfToken(options.url);
//             }
//             return $.rawAjaxJSONP.call(this, options);
//         };
//     }
// };

module.exports = security;
